module.exports = __webpack_public_path__ + "img/exhibition-4.820c500b.png";